import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    width: Number,
    storageKey: { type: String, default: "default" }
  }

  connect() {
    const key = `progress-bar-last-width:${this.storageKeyValue}`
    const lastWidth = parseInt(sessionStorage.getItem(key) || "0", 10)

    // Start from the previous width so consecutive Turbo Stream replacements animate smoothly
    this.element.style.transition = "none"
    this.element.style.width = `${lastWidth}%`

    // Animate to the new width on next frame
    requestAnimationFrame(() => {
      this.element.style.transition = ""
      this.element.style.width = `${this.widthValue}%`
    })

    sessionStorage.setItem(key, this.widthValue)

    if (this.widthValue >= 100) {
      sessionStorage.removeItem(key)
    }
  }
}
